import {Line} from "react-chartjs-2";
import React from "react";
import {DashboardBarChartDataMapType} from "../../../interface";

interface Props {
    title: string
    paramData: DashboardBarChartDataMapType
    view: number
}

export default function BarChart({title, paramData, view}: Props) {
    const list1 = view === 1
        ? paramData.dashboardSingleVOList?.map(el => el.revenueValue)
        : paramData.dashboardSingleVOList?.map(el => el.transferRevenueValue);
    const list2 = paramData.dashboardSingleVOList?.map(el => el.revenueGoal);

    const data: any = {
        // labels: ["홍길동", "김연아", "박지성", "손흥민", "ES팀"],
        labels: paramData.dashboardSingleVOList?.map(el => el.dataName),
        datasets: [
            {
                yAxisID: "left-y-axis",
                type: "bar",
                label: "합계",
                borderColor: "#1676E1",
                backgroundColor: "#1676E1",
                hoverBackgroundColor: "#1676E1",
                borderWidth: 0,
                fill: true,
                barThickness: 13,
                data: list1
            },
            {
                yAxisID: "left-y-axis",
                type: "bar",
                label: "목표",
                borderColor: "#54E3BF",
                backgroundColor: "#54E3BF",
                hoverBackgroundColor: "#54E3BF",
                borderWidth: 0,
                fill: true,
                barThickness: 13,
                data: list2
            }
        ]
    };

    const maxNumber = Math.max(...(list1 || []), ...(list2 || []));

    const options: any = {
        plugins: {
            datalabels: {
                display: false
            },
            legend: {
                display: true,
                position: "bottom"
            },
            // tooltip: {
            //     enabled: false,
            //     external: function (context: any) {
            //         // Tooltip Element
            //         let tooltipEl: any = document.getElementById('chartjs-tooltip');
            //
            //         // Create element on first render
            //         if (!tooltipEl) {
            //             tooltipEl = document.createElement('div');
            //             tooltipEl.id = 'chartjs-tooltip';
            //             tooltipEl.innerHTML = '<table></table>';
            //             document.body.appendChild(tooltipEl);
            //         }
            //
            //         // Hide if no tooltip
            //         const tooltipModel = context.tooltip;
            //         if (tooltipModel.opacity === 0) {
            //             tooltipEl.style.opacity = 0;
            //             return;
            //         }
            //
            //         // Set caret Position
            //         tooltipEl.classList.remove('above', 'below', 'no-transform');
            //         if (tooltipModel.yAlign) {
            //             tooltipEl.classList.add(tooltipModel.yAlign);
            //         } else {
            //             tooltipEl.classList.add('no-transform');
            //         }
            //
            //         function getBody(bodyItem: any) {
            //             return bodyItem.lines;
            //         }
            //
            //         // Set Text
            //         if (tooltipModel.body) {
            //             const titleLines = tooltipModel.title || [];
            //             const bodyLines = tooltipModel.body.map(getBody);
            //
            //             let innerHtml = '<thead>';
            //
            //             titleLines.forEach(function (title: any) {
            //                 innerHtml += '<tr><th>' + title + '</th></tr>';
            //             });
            //             innerHtml += '</thead><tbody>';
            //
            //             bodyLines.forEach(function (body: any, i: any) {
            //                 let temp = body[i].split(": ");
            //                 const colors = tooltipModel.labelColors[i];
            //                 let style = 'background:' + colors.backgroundColor;
            //                 style += '; border-color:' + colors.borderColor;
            //                 style += '; border-width: 2px';
            //                 const span = '<span class="dot_round" style="' + style + '"></span>';
            //                 innerHtml += '<tr><td>' + span + temp[1] + '</td></tr>';
            //             });
            //             innerHtml += '</tbody>';
            //
            //             let tableRoot = tooltipEl.querySelector('table');
            //             tableRoot.innerHTML = innerHtml;
            //         }
            //
            //         const position = context.chart.canvas.getBoundingClientRect();
            //         // const bodyFont = Chart.helpers.toFont(tooltipModel.options.bodyFont);
            //
            //         // Display, position, and set styles for font
            //         tooltipEl.style.opacity = 1;
            //         tooltipEl.style.position = 'absolute';
            //         tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
            //         tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
            //         // tooltipEl.style.font = bodyFont.string;
            //         tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px';
            //         tooltipEl.style.pointerEvents = 'none';
            //     }
            // }
        },
        fill: false,
        interaction: {
            intersect: false
        },
        radius: 0,
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                grid: {
                    display: false
                }
            },
            "left-y-axis": {
                beginAtZero: true,
                max: maxNumber !== 0 ? maxNumber : 100,
                min: 0,
                type: "linear",
                position: "left",
                grid: {
                    borderDash: [8, 6],
                    lineWidth: 2
                },
                ticks: {
                    callback: (v: any) => v + "",
                    maxTicksLimit: 6
                }
            }
        }
    };


    return <Line data={data} options={options}/>;
}